import request from '@/utils/request';
import { getUrlByGeneralInYinyitong } from '@/utils/defaultParameter';

const serviceName = 'datasync-dataviewsimulator';
const controllerName = 'yinyitong';
/**
 * 住院患者信息查询
 * InPatientNo  string  就诊卡
 * eventid      string   事件id
 */
export function inpatientQuery(data) {
  const interfaceName = '/inpatient/inpatient/query';
  const url = getUrlByGeneralInYinyitong(serviceName, controllerName, interfaceName);
  return request({
    url,
    method: 'post',
    data
  });
}
/**
 * 住院患者缴费记录查询
 * InpatientCode  string  住院号
 * beginDate      Date  开始时间(时间戳)
 * endDate        Date  结束时间(时间戳)
 * eventid      string   事件id
 */
export function inpatientBills(data) {
  const interfaceName = '/inpatient/bills';
  const url = getUrlByGeneralInYinyitong(serviceName, controllerName, interfaceName);
  return request({
    url,
    method: 'post',
    data
  });
}

/**
 * 住院患者充值记录查询
 * InpatientCode  string  住院号
 * beginDate      Date  开始时间(时间戳)
 * endDate        Date  结束时间(时间戳)
 * eventid      string   事件id
 */
export function depositPayRecords(data) {
  const interfaceName = '/inpatient/depositPay/records';
  const url = getUrlByGeneralInYinyitong(serviceName, controllerName, interfaceName);
  return request({
    url,
    method: 'post',
    data
  });
}
